module.exports = __webpack_public_path__ + "img/newxcoins_logo_light_menu.3af565a7.png";